import { KINDS } from './schema.js';
import { maxHlc } from './hlc.js';

async function sha256Hex(str) {
  const buf = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Per-kind { count, digest } over rows shaped { id, _hlc }. Must match
 * public.sync_summary(): sha256 of "id@maxHlc" joined by "," in id order.
 */
export async function localSummary(rowsByKind) {
  const out = {};
  for (const [kind, rows] of Object.entries(rowsByKind)) {
    const parts = rows
      .filter((r) => r._hlc && Object.keys(r._hlc).length)
      .map((r) => ({ id: r.id, s: `${r.id}@${maxHlc(Object.values(r._hlc)) ?? ''}` }))
      .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
    if (!parts.length) continue;
    out[kind] = { count: parts.length, digest: await sha256Hex(parts.map((p) => p.s).join(',')) };
  }
  return out;
}

export async function dbSummary(db) {
  const rowsByKind = {};
  for (const [kind, def] of Object.entries(KINDS)) rowsByKind[kind] = await db[def.table].toArray();
  return localSummary(rowsByKind);
}

export function summariesEqual(a, b) {
  const kinds = new Set([...Object.keys(a ?? {}), ...Object.keys(b ?? {})]);
  for (const k of kinds) {
    const x = a?.[k];
    const y = b?.[k];
    if (Number(x?.count ?? 0) !== Number(y?.count ?? 0)) return false;
    if ((x?.digest ?? null) !== (y?.digest ?? null)) return false;
  }
  return true;
}
